




































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { timeFormat, jsIntString } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
import { UserWorkStatusRangeEnum } from "@/enum/index";

import {
  GetUserListReq
} from "@/pbjs/external/user/user_pb";

@Component({
  name: "StaffManagement"
})
export default class StaffManagement extends Vue {
  @Provide() private issearchUserDone: boolean = false;
  @Provide() private dialogVisible: boolean = false;
  @Provide() private disabledVisible: boolean = false; //批量操作是否可点击
  @Provide() private dialogDefine: boolean = false; //批量操作弹窗内确认按钮是否可点击
  // 角色
  @Provide() private roleData: any = [];
  @Provide() private role: string = "";
  @Provide() private labelPosition: string = "right";
  @Provide() private resultData: any = []; // lee table列表
  @Provide() private selectionList: number[] = []; // 多选列表
  @Provide() private token: any = "";
  @Provide() private pagnition: any = pagnition; // lee 分页参数
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private inputName: string = ""; // 员工姓名
  @Provide() private userWorkStatus: string = "";
  @Provide() private userId: number | null = null; //员工ID
  @Provide() private execType: number | null = 3; //角色
  @Provide() private workStatus: number | null = null; // 工作状态
  @Provide() private twoFactAuthRange: number | null = null;
  @Provide() private outSourceRange: number | null = null;
  // 工作状态筛选框列表
  @Provide() private UserWorkStatusRangeEnum: any = Object.entries(UserWorkStatusRangeEnum)
    .slice(1)
    .map((item: any, index: number) => {
      switch (index) {
        case 0:
          item[2] = "ticketLgy.All";
          break;
        case 1:
          item[2] = "v0707.Yes";
          break;
        case 2:
          item[2] = "v0707.No";
          break;
      }
      return item;
    });

  private created() {
    console.log(Object.entries(UserWorkStatusRangeEnum).slice(1))
    this.token = localStorage.getItem("token");
    this.getRoleList()
    this.searchPersonnel()
  }
  private radioChange() {
    this.dialogDefine = this.userWorkStatus ? true : false;
  }
  private async getRoleList() {
    let _arg: any = {
      execType: this.execType,
    }
    const {
      setListUserGroupByTypeReq,
      getListUserGroupByTypeRequest
    }: any = await import("@/request/staffManagement");
    let res = await getListUserGroupByTypeRequest.handleHttp(
      setListUserGroupByTypeReq(_arg),
      null
    );
    if (res && res.right) {
      console.log(res, "getUserListRequest");
      if (res.usergroupinfosList && res.usergroupinfosList.length > 0) {
        this.roleData = res.usergroupinfosList
      } else {
        this.roleData = [];
      }
    } else {
      this.$message.error(res.commonout.errmsg);
    }
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.searchPersonnel();
  }
  private resetForm() {
    this.inputName = ""; // 员工姓名
    this.userId = null; //员工ID
    this.role = ""; // 角色
    this.workStatus = null; // 工作状态
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.searchPersonnel();
  }
  private handleClose(done: any) {
    done();
  }
  private async goDetail() {
    console.log(this.selectionList)
    if (this.selectionList && this.selectionList.length > 0) {
      this.dialogVisible = true;
    }
  }
  private async operation(val: any) {
    this.dialogVisible = false;
    if (typeof (val) == "undefined") {
      this.userWorkStatus = this.userWorkStatus;
      this.selectionList = this.selectionList
    } else {
      this.userWorkStatus = val.workstatus === 1 ? "2" : "1";
      this.selectionList = [val.id]
    }
    let _arg = {
      userWorkStatus: +this.userWorkStatus, //工作状态
      selectionList: this.selectionList
    }
    const {
      setBatchUpdateUserWorkStatusReq,
      getBatchUpdateUserWorkStatusRequest
    }: any = await import("@/request/staffManagement");
    let res = await getBatchUpdateUserWorkStatusRequest.handleHttp(
      setBatchUpdateUserWorkStatusReq(_arg),
      null
    );
    console.log(res)
    if (res && res.right) {
      this.userWorkStatus = ""
      this.searchPersonnel();
    } else {
      this.$message.error(res.errmsg);
    }
  }

  private handleSelectionChange(val: any) {
    if (val) {
      this.selectionList = val.map((item: any) => {
        return item.id;
      });
      this.disabledVisible = val.length >= 2 ? true : false
    }
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.searchPersonnel();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.searchPersonnel();
  }

  // 处理搜索用户的参数
  private dwGetUserListFuc() {
    let _arg: any = {
      inputName: this.inputName,
      inputEmail: "",
      roleValue: this.role,
      userStatus: "",
      attendancetimefrom: "",
      attendancetimeto: "",
      userId: this.userId, // 员工ID
      employeeId: "",
      workstatus: this.workStatus ? this.workStatus : 1, //工作状态
      execType: this.execType, //角色
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
    }
    return _arg;
  }
  private searchPersonnel() {
    const _arg = this.dwGetUserListFuc();
    this.dwSearchUserRequest(_arg);
  }
  //  搜索用户列表
  private async dwSearchUserRequest(_arg: any) {
    const {
      setGetUserListReq,
      getUserListRequest
    }: any = await import("@/request/staffManagement");
    let res = await getUserListRequest.handleHttp(
      setGetUserListReq(_arg),
      null
    );
    this.issearchUserDone = res ? res.loading : false;
    if (res && res.right) {
      console.log(res, "getUserListRequest");
      if (res.userinfosList && res.userinfosList.length > 0) {
        res.userinfosList.forEach((item: any) => {
          let time = item.operatetime ? '--' : timeFormat(item.operatetime);  //现在go没返回数据，沟通后暂时先这样
          item.operatetime = time;
        })
        this.resultData = res.userinfosList;
      } else {
        this.resultData = [];
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }

}
